import { colors, typography, zIndex } from "src/assets/styles/settings";
import styled from "styled-components";

export const typeColors = {
  white: {
    background: colors.white,
    color: colors.dark_smoke,
    border: colors.disabled
  },
  black: {
    background: colors.black_bekko,
    color: colors.white,
    border: colors.dark_grey
  },
  blue: {
    background: colors.bubble,
    color: colors.space_blue,
    border: colors.tie_dye
  },
  green: {
    background: colors.light_jade,
    color: colors.spinach,
    border: colors.slight_jade
  },
  grey: {
    background: colors.light_smoke,
    color: colors.dark_smoke,
    border: colors.light_grey
  },
  red: {
    background: colors.sakura,
    color: colors.red_wine,
    border: colors.blush
  },
  yellow: {
    background: colors.banana,
    color: colors.coin,
    border: colors.blonde
  },
  "dark-blue": {
    background: colors.dark_blue,
    color: colors.white,
    border: colors.dark_grey
  }
};

export const TooltipWrapperStyled = styled.div`
  position: relative;
  z-index: ${zIndex.popupTooltip};
`;

export const TooltipContent = styled.div<{ color: keyof typeof typeColors }>`
  position: relative;
  font-size: ${typography.font_size.small};
  background: ${({ color }) => typeColors[color].background || typeColors.white.background};
  color: ${({ color }) => typeColors[color].color || typeColors.white.color};
  border: 1px solid ${({ color }) => typeColors[color].border || typeColors.white.border};
  border-radius: 8px;
  max-width: 280px;

  &.visible {
    transition: opacity 0.2s;
    opacity: 1;
  }

  &.hidden {
    transition: opacity 0.3s;
    opacity: 0;
  }

  .tooltip-arrow {
    width: 17px;
    height: 10px;
    position: absolute;
    overflow: hidden;
    transform-origin: top;

    &:before {
      content: "";
      position: absolute;
      width: 15px;
      height: 15px;
      background: ${({ color }) => typeColors[color].background || typeColors.white.background};
      border: 1px solid ${({ color }) => typeColors[color].border || typeColors.white.border};
      transform: translateX(-50%) translateY(-100%) rotate(45deg);
      top: 50%;
      left: 50%;
      box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%);
    }
  }
`;

export const TooltipPosition = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: ${zIndex.popupTooltip};
`;
